export default "__VITE_ASSET__dc539896__"